import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withComponentInputBinding, withHashLocation, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from "@angular/platform-browser";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {AbstractLoggerService, AuthInterceptor, provideAuth} from "angular-auth-oidc-client";
import {AuthLoggerService} from "./security/auth-logger.service";
import {environment} from "../environments/environment";
import {FeatherModule} from "angular-feather";
import {allIcons} from "angular-feather/icons";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {Http404Interceptor} from "./shared/commons/interceptor/http404-interceptor";
import {Http400Interceptor} from "./shared/commons/interceptor/http400-interceptor";
import {http500Interceptor} from "./interceptors/http500_interceptor";
import {http429Interceptor} from "./interceptors/http429_interceptor";
import {loadingInterceptor} from "./interceptors/loading_interceptor";
import {Http401Interceptor} from "./shared/commons/interceptor/http401-interceptor";
import {Http403Interceptor} from "./shared/commons/interceptor/http403-interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withHashLocation(),
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
      withComponentInputBinding()
    ),
    provideClientHydration(),
    provideHttpClient(
      // withFetch(),
      withInterceptors([
        loadingInterceptor,
        http500Interceptor,
        http429Interceptor
      ]),
      withInterceptorsFromDi()
    ),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Http400Interceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Http401Interceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Http404Interceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Http403Interceptor, multi: true},
    provideAnimations(),
    provideAnimationsAsync(),
    provideAuth({
      config: {
        secureRoutes: [environment.serverUrl, ''],
        authority: environment.oidcIssuerUrl,
        redirectUrl: window.location.origin + '/#/callback',
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.clientId,
        scope: 'openid profile email', // 'openid profile offline_access ' + your scopes
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        autoUserInfo: true,
        renewUserInfoAfterTokenRenew: true,
        ignoreNonceAfterRefresh: true,
        renewTimeBeforeTokenExpiresInSeconds: 60,
        startCheckSession: true,
        triggerRefreshWhenIdTokenExpired: true,
        logLevel: environment.ngOidcLogLevel,
        maxIdTokenIatOffsetAllowedInSeconds:900 //15min
      },
    }),
    {provide: AbstractLoggerService, useClass: AuthLoggerService},
    importProvidersFrom(FeatherModule.pick(allIcons))
  ]
};

